export const DEFAULT_SNACK_CFG = {
  duration: 3000,
};
